import { useEffect, useMemo, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import { GetCategoriesData, GetOrdersData, GetOrdersExportData } from "../../lib/data";
import Button from "../../components/GButton/Button";
import { ordersColumns, stateOfOrders } from "../../lib/definitions";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { MdOutlineFileUpload } from "react-icons/md";
import OrdersFilter from "../../ui/searchFilter/ordersFilter";
import { updateConfirmOrdersForm } from "../../lib/actions";
import ConfirmRecord from "../../ui/Models/confirmRecord";
import OrderDetailsPop from "../../ui/orders/orderDetailsPop";
import { getOrderByUserId } from "../../lib/apiCalls";
import NotData from "../../ui/sharedUi/noData";
import i18n from "../../lib/i18n";

export default function Orders() {

    const [searchParams] = useSearchParams();
    const orderRef = useRef(null);
    const confirmRef = useRef(null);
    const [ordersData, setOrdersData] = useState([]);
    const [ordersExportData, setOrdersExportData] = useState([]);
    const [categoriesParentDataFilter, setCategoriesParentDataFilter] = useState([]);
    const [categoriesChildDataFilter, setCategoriesChildDataFilter] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [confirmation, setConfirmation] = useState({ isOpen: false, idToConfirm: null });
    const [openDetails, setOpenDetails] = useState({ isOpen: false, idToOpen: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [showExportDialog, setShowExportDialog] = useState(false);
    const location = useLocation(); 
    const [loadingConfirm, setLoadingConfirm] = useState(false); 
    const category_id = searchParams.get('category_id');
    const sub_category_id = searchParams.get('sub_category_id');
    const name = searchParams.get('name');
    const status = searchParams.get('status');
    const min_price = searchParams.get('min_price');
    const max_price = searchParams.get('max_price');
    const from_date = searchParams.get('from_date');
    const to_date = searchParams.get('to_date');
    const id = searchParams.get('id');
    const {userId} = useParams();
    const t = i18n.t.bind(i18n); 
    

    const params = useMemo(() => {
        const tempParams = [];
        if (category_id) tempParams.push({ category_id });
        if (sub_category_id) tempParams.push({ sub_category_id });
        if (name) tempParams.push({ name });
        if (min_price) tempParams.push({ min_price });
        if (max_price) tempParams.push({ max_price });
        if (from_date) tempParams.push({ from_date });
        if (to_date) tempParams.push({ to_date });
        if (status) tempParams.push({ status });
        if (id) tempParams.push({ id });

        return tempParams;
    }, [ id, sub_category_id, category_id, name, min_price, max_price, from_date, to_date, status]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            orderRef.current && 
            !orderRef.current.contains(event.target)
            ) {
                setOpenDetails({ idToOpen : false });
            }
        };

        if (openDetails.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [openDetails.isOpen]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            confirmRef.current && 
            !confirmRef.current.contains(event.target)
            ) {
                closeConfirmation();
            }
        };

        if (confirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        };
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [confirmation.isOpen]);

    useEffect(() => {
        handleApi();
        setConfirmation({ isOpen: false, idToConfirm: null });
    }, [currentPage, params ])

    useEffect(() => {
        handleFilterCategoryParent();
        handleFilterCategoryChlid();
    }, [])

    const handleApi = async () => {
        setIsLoading(true); 
        let ordersData = [];
        if(location.pathname.startsWith("/users/details/")){
            ordersData = await getOrderByUserId(userId, currentPage, params);
            setOrdersData([]);
            ordersData.data.data.map((e) => setOrdersData((prev) => [...prev, e]));
            setcurrentPage(ordersData.data.pagination.current_page);
            setlast_page(ordersData.data.pagination.last_page);
        }
        else{
            ordersData = await GetOrdersData(currentPage, params);
            setOrdersData([]);
            ordersData.data.map((e) => setOrdersData((prev) => [...prev, e]));
            setcurrentPage(ordersData.pagination.current_page);
            setlast_page(ordersData.pagination.last_page);
        }
        setIsLoading(false);  
    };

    const handleFilterCategoryParent = async () => {
        const params = [ {"status" : "main"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesParentDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
    };

    const handleFilterCategoryChlid = async () => {
        const params = [ {"status" : "sub"} ];
        const categoriesDataFilter = await GetCategoriesData(1, params);
        setCategoriesChildDataFilter([]);
        categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
    };

    const searchCategoryParent = async (param) => {
        const params = [ {"name": param},{"status" : "main"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesParentDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesParentDataFilter((prev) => [...prev, e]));
        }
    };

    const searchCategoryChild = async (param) => {
        const params = [ {"name": param},{"status" : "sub"} ];
        if(param){
            const categoriesDataFilter = await GetCategoriesData(1,params);
            setCategoriesChildDataFilter([]);
            categoriesDataFilter.data.map((e) => setCategoriesChildDataFilter((prev) => [...prev, e]));
        }
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openConfirmation = (id) => {
        setConfirmation({ isOpen: true, idToConfirm: id });
    };

    const closeConfirmation = () => {
        setConfirmation({ isOpen: false, idToConfirm: null });
    };

    const handelConfirm = async (status, value) => {
        if (confirmation.idToConfirm) {
            setLoadingConfirm(true);
            let params = [];
            if(value){
                params = {"status" : status, "reject_reason" : value};
            }
            else {
                params = {"status" : status};
            }
            const result = await updateConfirmOrdersForm(confirmation.idToConfirm, params);
            if (result) { 
                handleApi();
            }
            setLoadingConfirm(false);
            closeConfirmation();
        }
    };

    const openOrderDetails = (id) => {
        setOpenDetails({ isOpen: true, idToOpen: id });
    };

    const openCloseExportDialog = (e) => {
        setShowExportDialog(e);
    };

    const ExportTableWithPaginiation = async (e) => {
        const orderExportData = await GetOrdersExportData(e, params);
        setOrdersExportData([]);
        orderExportData.data.map((e) => setOrdersExportData((prev) => [...prev, e]));
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
           
            <div className="">
                <OrdersFilter searchCategoryParent={searchCategoryParent} searchCategoryChild={searchCategoryChild} categoriesChildData={categoriesChildDataFilter} categoriesParentData={categoriesParentDataFilter} stateOfOrders={stateOfOrders} values={params} />
            </div>
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <h1 className="text-white text-lg ">{t("nav.orders")}</h1>
                <div onClick={()=>openCloseExportDialog(true)}>
                    <Button background="#232424" borderRadius="8px" border="border border-gray-500/80" color="white" padding="8px 24px" text={t("button.export")} icon={<MdOutlineFileUpload />} />
                </div>
            </div>
        
            { (ordersData.length > 0 || isLoading) &&
                <div>
                    {isLoading ? <TableSkeleton cols={ordersColumns}/> : (  
                        <Table name={"Orders"} showExportDialog={showExportDialog} openCloseExportDialog={openCloseExportDialog} ExportTableWithPaginiation={ExportTableWithPaginiation} rowsExportPaginiation={ordersExportData} columns={ordersColumns} rows={ordersData} action="confirm" openConfirmation={openConfirmation} openOrderDetails={openOrderDetails} />
                    )}
                </div>
            }
            { (ordersData.length < 1 && !isLoading) &&
                <div>
                    <NotData />
                </div>
            }
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {confirmation.isOpen && <ConfirmRecord ref={confirmRef} loadingConfirm={loadingConfirm} handelConfirm={handelConfirm} closeConfirmation={closeConfirmation} />}
            {openDetails.isOpen && openDetails.idToOpen && <OrderDetailsPop ref={orderRef} data={ordersData.find(order => order.id === openDetails.idToOpen)} onClose={() => setOpenDetails({ idToOpen : false })} />}
        </div>
    );
};